// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.folder-selector-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.folder-selector-modal {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.folder-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
}

.folder-selector-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.folder-selector-header .btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  line-height: 1;
}

.folder-selector-header .btn-close:hover {
  color: #333;
}

.folder-selector-breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 12px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.folder-selector-breadcrumb .breadcrumb-item {
  background: none;
  border: none;
  color: #1976d2;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
}

.folder-selector-breadcrumb .breadcrumb-item:hover {
  background: #e3f2fd;
}

.folder-selector-breadcrumb .breadcrumb-separator {
  color: #999;
}

.folder-selector-error {
  padding: 12px 20px;
  background: #ffebee;
  color: #c62828;
  font-size: 14px;
}

.folder-selector-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
  min-height: 200px;
  max-height: 300px;
}

.folder-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.15s;
}

.folder-item:hover {
  background: #e3f2fd;
}

.folder-item.folder-up {
  color: #666;
}

.folder-icon {
  font-size: 20px;
}

.folder-name {
  font-size: 15px;
  color: #333;
}

.folder-selector-loading,
.folder-selector-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  color: #666;
  font-size: 14px;
}

.folder-selector-footer {
  padding: 16px 20px;
  border-top: 1px solid #e0e0e0;
  background: #fafafa;
}

.selected-path {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.path-label {
  color: #666;
  font-size: 13px;
}

.path-value {
  color: #1976d2;
  font-weight: 500;
  font-size: 14px;
  word-break: break-all;
}

.folder-selector-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.folder-selector-actions .btn-cancel {
  padding: 10px 20px;
  border: 1px solid #ccc;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}

.folder-selector-actions .btn-cancel:hover {
  background: #f5f5f5;
}

.folder-selector-actions .btn-select {
  padding: 10px 20px;
  border: none;
  background: #1976d2;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.folder-selector-actions .btn-select:hover {
  background: #1565c0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Folder/FolderSelector.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".folder-selector-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.folder-selector-modal {\n  background: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.folder-selector-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.folder-selector-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.folder-selector-header .btn-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  line-height: 1;\n}\n\n.folder-selector-header .btn-close:hover {\n  color: #333;\n}\n\n.folder-selector-breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 12px 20px;\n  background: #f5f5f5;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.folder-selector-breadcrumb .breadcrumb-item {\n  background: none;\n  border: none;\n  color: #1976d2;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.folder-selector-breadcrumb .breadcrumb-item:hover {\n  background: #e3f2fd;\n}\n\n.folder-selector-breadcrumb .breadcrumb-separator {\n  color: #999;\n}\n\n.folder-selector-error {\n  padding: 12px 20px;\n  background: #ffebee;\n  color: #c62828;\n  font-size: 14px;\n}\n\n.folder-selector-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n  min-height: 200px;\n  max-height: 300px;\n}\n\n.folder-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: background 0.15s;\n}\n\n.folder-item:hover {\n  background: #e3f2fd;\n}\n\n.folder-item.folder-up {\n  color: #666;\n}\n\n.folder-icon {\n  font-size: 20px;\n}\n\n.folder-name {\n  font-size: 15px;\n  color: #333;\n}\n\n.folder-selector-loading,\n.folder-selector-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100px;\n  color: #666;\n  font-size: 14px;\n}\n\n.folder-selector-footer {\n  padding: 16px 20px;\n  border-top: 1px solid #e0e0e0;\n  background: #fafafa;\n}\n\n.selected-path {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n}\n\n.path-label {\n  color: #666;\n  font-size: 13px;\n}\n\n.path-value {\n  color: #1976d2;\n  font-weight: 500;\n  font-size: 14px;\n  word-break: break-all;\n}\n\n.folder-selector-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.folder-selector-actions .btn-cancel {\n  padding: 10px 20px;\n  border: 1px solid #ccc;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666;\n}\n\n.folder-selector-actions .btn-cancel:hover {\n  background: #f5f5f5;\n}\n\n.folder-selector-actions .btn-select {\n  padding: 10px 20px;\n  border: none;\n  background: #1976d2;\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.folder-selector-actions .btn-select:hover {\n  background: #1565c0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
